var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-serach" },
    [
      _c(
        "flex",
        { staticClass: "search-input", attrs: { align: "center" } },
        [
          _c(
            "flex",
            { staticClass: "input-wrapper", attrs: { align: "center" } },
            [
              _c("el-autocomplete", {
                staticClass: "home-input",
                staticStyle: { height: "100%" },
                attrs: {
                  "fetch-suggestions": _vm.querySearch,
                  "trigger-on-focus": false,
                  placeholder: _vm.searchHint || "请输入关键字"
                },
                on: { select: _vm.handleSelect },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchByKeyWord.apply(null, arguments)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", { staticClass: "addr" }, [
                          _vm._v(_vm._s(item))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.keyWord,
                  callback: function($$v) {
                    _vm.keyWord = $$v
                  },
                  expression: "keyWord"
                }
              }),
              _vm._v(" "),
              _c(
                "flex",
                {
                  staticClass: "search-icon",
                  attrs: { justify: "center", align: "center" },
                  on: { click: _vm.searchByKeyWord }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/static/img/home/search-icon-white.png")
                    }
                  }),
                  _vm._v("\n        搜索\n      ")
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "flex",
            {
              staticClass: "type",
              attrs: { align: "center", justify: "center" },
              on: { click: _vm.showHighSearch }
            },
            [_vm._v("\n      高级搜索\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hot-search" },
        [
          _c("span", { staticClass: "hot-search-item" }, [
            _vm._v("热门搜索：")
          ]),
          _vm._v(" "),
          _vm._l(_vm.hotWrods, function(item, index) {
            return _c(
              "span",
              {
                key: index,
                staticClass: "hot-search-item hot-words",
                attrs: { title: item },
                on: {
                  click: function($event) {
                    return _vm.handleSelect(item)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(item) + "\n    ")]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "main-dialog",
        {
          attrs: {
            "dialog-visible": _vm.highSearchShow,
            "to-body": true,
            width: "850px",
            top: "20vh",
            title: "高级搜索"
          },
          on: {
            "update:dialogVisible": function($event) {
              _vm.highSearchShow = $event
            },
            "update:dialog-visible": function($event) {
              _vm.highSearchShow = $event
            }
          }
        },
        [_c("high-search", { on: { "high-search": _vm.searchByHigh } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }